import { Application } from "@hotwired/stimulus"
import { ApolloClient, InMemoryCache, createHttpLink, ApolloLink, concat } from "@apollo/client"

let application

function startApplication() {
  if (!application) {
    application = Application.start()
    application.debug = false

    const httpLink = createHttpLink({
      uri: "/api/graphql",
    })

  // Environment meta tag is required for CSRF token handling.
  // Applies a fallback environment in case the meta tag is missing.
  // If missing, it would throw a TypeError and break CSRF token handling for all
  // GraphQL requests, creating a security vulnerability.
  const environmentMeta = document.querySelector('meta[name="environment"]')
  const environment = environmentMeta ? environmentMeta.content : 'production'
   const csrfToken =
     environment == "test" ? "" : document.querySelector('meta[name="csrf-token"]').content

    let authMiddleware = new ApolloLink((operation, forward) => {
      operation.setContext({
        headers: {
          "X-CSRF-Token": csrfToken,
        },
      })

      return forward(operation)
    })

    // TODO: Worth looking into using ApolloClient as a state management solution.
    // Looks to persist between pages and is singleton.
    let client = new ApolloClient({
      // connectToDevTools: true, //uncomment if you want to connect with apollo client on dev
      link: concat(authMiddleware, httpLink),
      cache: new InMemoryCache(),
    })
    application.apolloClient = client
    window.Stimulus = application
  }
  return application
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startApplication)
} else {
  startApplication()
}

export { startApplication as getApplication }
